export const LOAD_ADMIN_LIST = 'load_admin_list';
